export const queryKeys = {
  getSettings: "getSettings",
};
